import i18nFactory, { i18nRaw as i18nRawFactory } from '@yandex-int/i18n';
import { Button } from 'lego-on-react';
import * as React from 'react';

import { RecommendationCharacter, RecommendationType } from '../../../typings/recommendations';
import { Shape2Icon } from '../../Shape2/Shape2';
import { RecommendationCard, RecommendationCardView } from '../RecommendationCard';

import * as keyset from './AddCreativesRecommendationCard.i18n';

const i18n = i18nFactory(keyset);
const i18nRaw = i18nRawFactory(keyset);

export interface AddCreativesRecommendationCardProps {
    character: RecommendationCharacter;
    formats?: Array<string>;
    view: RecommendationCardView;
    onClose?: () => void;
    title?: string;
    titleHint?: string;
}

export const AddCreativesRecommendationCard = React.memo(
    (props: AddCreativesRecommendationCardProps): JSX.Element | null => {
        const { view, character, formats, onClose, title, titleHint } = props;

        if (!(formats && formats.length)) {
            return null;
        }

        const titleRecommendation = title || getTitle(view);
        const titleHintRecommendation = titleHint || getTitleHint(view);

        return (
            <RecommendationCard
                type={RecommendationType.addBannerFormats}
                view={view}
                icon={Shape2Icon.lamp}
                character={character}
                title={titleRecommendation}
                titleHint={titleHintRecommendation}
                buttons={getButtons(view, onClose)}
                isInProgress={false}
            >
                {i18nRaw('add-creatives', {
                    formats: <b key={1}>{getFormats(formats)}</b>,
                    count: formats.length
                })}
            </RecommendationCard>
        );
    }
);

const getTitle = (view: RecommendationCardView): string | undefined => {
    switch (view) {
        case RecommendationCardView.short:
            return;

        case RecommendationCardView.recommendationsPopup:
            return i18n('title');

        default:
            return;
    }
};

const getTitleHint = (view: RecommendationCardView): string | undefined => {
    switch (view) {
        case RecommendationCardView.short:
            return;

        case RecommendationCardView.recommendationsPopup:
            return i18n('title-hint');

        default:
            return;
    }
};

const getButtons = (view: RecommendationCardView, onClose?: () => void) => {
    if (!onClose) {
        return;
    }

    switch (view) {
        case RecommendationCardView.short:
            return [<Button key={1} theme={'pseudo'} size={'n'} text={i18n('close')} onClick={onClose} />];

        case RecommendationCardView.recommendationsPopup:
            return;

        default:
            return;
    }
};

const getFormats = (formats: Array<string>) => {
    return formats
        .map(format => {
            return `${format}px`;
        })
        .join(', ');
};
